/*
 * WEGO — pret produs: sticky bar + evidentierea pretului redus
 * ---------------------------------------------------------------------------
 * Doua lucruri, in acelasi fisier fiindca depind de aceleasi elemente.
 *
 * 1) STICKY BAR
 *    Aplicatia de discount (Discount Mixer) scrie intr-un SINGUR element de pe
 *    pagina — primul care ii corespunde. De cand sablonul de produs are un bloc
 *    de pret sub titlu, acela e primul, iar sticky bar-ul ramane cu pretul
 *    intreg. Scriptul citeste ce a randat aplicatia si oglindeste in sticky bar.
 *
 * 2) EVIDENTIEREA PRETULUI REDUS
 *    Aplicatia isi scrie marimea si grosimea ca variabile CSS inline, INAUNTRU
 *    in shadow DOM (.dmixer-dp-wrapper), unde CSS-ul temei nu ajunge. Shadow
 *    root-ul e deschis, asa ca le suprascriem din JS.
 *
 * Cum lucreaza aplicatia (verificat in DOM, 08.2026):
 *   - adauga clasa .dmixer-original-price pe <span data-product-price> al temei
 *   - insereaza <dmixer-discounted-price> si <dmixer-sale-badge>, ambele cu
 *     shadow DOM; textul se citeste din shadowRoot, nu din textContent
 *   - <s data-compare-price> al temei ramane gol si ascuns
 *
 * Daca aplicatia lipseste, se cade pe pretul comparat nativ al temei.
 * Daca produsul nu are reducere, nu se schimba nimic.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var SRC = '.product__price-and-badge';
  var STICKY = '.cart-bar__product__price';

  /* Marimea pretului redus. clamp() ca sa nu iasa din ecran pe telefon. */
  var DP_FONT_SIZE = 'clamp(21px, 5.2vw, 26px)';
  var DP_FONT_WEIGHT = '800';
  var DP_COLOR = '#0a1a29';

  /* ---------- stiluri pentru partea din light DOM ---------- */
  function injectCss() {
    if (document.getElementById('wego-price-css')) return;
    var st = document.createElement('style');
    st.id = 'wego-price-css';
    st.textContent =
      '.product__price-and-badge .product__price{align-items:baseline;gap:10px;flex-wrap:wrap}' +
      '.product__price-and-badge .dmixer-original-price{font-size:15px;font-weight:500;opacity:.55}' +
      '.cart-bar__product__price [data-product-price]{font-weight:800}' +
      '.cart-bar__product__price [data-wego-compare]{opacity:.55;font-weight:500;margin-left:8px}';
    document.head.appendChild(st);
  }

  /* ---------- shadow DOM ---------- */
  function shadowText(host) {
    if (!host || !host.shadowRoot) return '';
    var parts = [];
    host.shadowRoot.querySelectorAll('*').forEach(function (el) {
      if (el.tagName === 'STYLE' || el.tagName === 'SCRIPT') return;
      if (el.children.length === 0) {
        var s = (el.textContent || '').trim();
        if (s) parts.push(s);
      }
    });
    return parts.join(' ').trim();
  }

  /* Aplicatia isi seteaza variabilele inline pe .dmixer-dp-wrapper din shadow.
     Le rescriem acolo, altfel nu avem cum sa le depasim din CSS. */
  function restyleDiscounted(src) {
    var host = src.querySelector('dmixer-discounted-price');
    if (!host || !host.shadowRoot) return;
    var w = host.shadowRoot.querySelector('.dmixer-dp-wrapper');
    if (!w) return;
    if (w.style.getPropertyValue('--dmixer-dp-font-size') === DP_FONT_SIZE) return;
    w.style.setProperty('--dmixer-dp-font-size', DP_FONT_SIZE);
    w.style.setProperty('--dmixer-dp-font-weight', DP_FONT_WEIGHT);
    w.style.setProperty('--dmixer-dp-color', DP_COLOR);
  }

  function txt(el) {
    return el ? (el.textContent || '').trim() : '';
  }

  function isVisible(el) {
    if (!el) return false;
    if (el.classList.contains('hidden')) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  /* Ce trebuie afisat in sticky bar: { price, compare, badge } sau null */
  function readSource(src) {
    var orig = src.querySelector('[data-product-price]');
    if (!orig) return null;

    var disc = shadowText(src.querySelector('dmixer-discounted-price'));
    if (disc) {
      return {
        price: disc,
        compare: txt(orig),
        badge: shadowText(src.querySelector('dmixer-sale-badge'))
      };
    }

    /* fara aplicatie: compare_at_price nativ, daca tema il arata */
    var cmp = src.querySelector('[data-compare-price]');
    if (cmp && isVisible(cmp) && txt(cmp) && txt(cmp) !== txt(orig)) {
      return { price: txt(orig), compare: txt(cmp), badge: '' };
    }

    return null;
  }

  function apply(sticky, data) {
    var p = sticky.querySelector('[data-product-price]');
    var c = sticky.querySelector('[data-wego-compare]');
    var b = sticky.querySelector('[data-wego-badge]');

    if (!data) {
      if (c) { c.textContent = ''; c.style.display = 'none'; }
      if (b) { b.textContent = ''; b.style.display = 'none'; }
      if (p) p.classList.remove('product__price--sale');
      return;
    }

    if (p && data.price && txt(p) !== data.price) p.textContent = data.price;
    if (p) p.classList.add('product__price--sale');

    if (c) {
      if (data.compare) {
        if (txt(c) !== data.compare) c.textContent = data.compare;
        /* display explicit, ca sa nu cada pe "block" din CSS-ul temei */
        c.style.display = 'inline';
      } else {
        c.textContent = '';
        c.style.display = 'none';
      }
    }

    if (b) {
      if (data.badge) {
        if (txt(b) !== data.badge) b.textContent = data.badge;
        b.style.display = 'inline-block';
      } else {
        b.textContent = '';
        b.style.display = 'none';
      }
    }
  }

  function sync() {
    var src = document.querySelector(SRC);
    if (!src) return;
    restyleDiscounted(src);
    var sticky = document.querySelector(STICKY);
    if (sticky) apply(sticky, readSource(src));
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = window.requestAnimationFrame(function () {
      pending = null;
      sync();
    });
  }

  function start() {
    var src = document.querySelector(SRC);
    if (!src) return; /* nu suntem pe o pagina de produs */

    injectCss();
    sync();

    /* Aplicatia injecteaza asincron, iar tema rescrie blocul de pret la
       schimbarea variantei. Urmarim ambele. */
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(src, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }

    /* Plasa de siguranta ~6s: shadow DOM-ul se randeaza dupa ce se incarca
       aplicatia, iar MutationObserver-ul de mai sus nu vede in shadow. */
    var ticks = 0;
    var iv = setInterval(function () {
      sync();
      if (++ticks >= 15) clearInterval(iv);
    }, 400);

    window.addEventListener('load', schedule);
    document.addEventListener('variant:change', schedule);
    document.addEventListener('product:variant-change', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
